import { icon } from '../../icons';
import { t } from '../../services/i18n';

type ConfirmDialogOptions = {
  title?: string;
  cancelLabel?: string;
  confirmVariant?: 'danger' | 'primary';
};

function getTopModalZIndex(): number {
  const overlays = Array.from(document.querySelectorAll<HTMLElement>('.modal-overlay'));
  return overlays.reduce((highest, element) => {
    const value = Number.parseInt(window.getComputedStyle(element).zIndex || '', 10);
    return Number.isFinite(value) ? Math.max(highest, value) : highest;
  }, 100);
}

export function confirmDialog(
  message: string,
  confirmLabel = t('common.delete'),
  options: ConfirmDialogOptions = {},
): Promise<boolean> {
  return new Promise((resolve) => {
    const title = options.title || t('confirm.title');
    const cancelLabel = options.cancelLabel || t('common.cancel');
    const confirmClassName = options.confirmVariant === 'primary' ? 'btn btn-primary' : 'btn btn-danger';
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.style.zIndex = String(getTopModalZIndex() + 10);
    overlay.innerHTML = `
      <div class="modal confirm-dialog">
        <div class="confirm-icon">
          ${icon('alert-circle', { size: 48, attrs: 'stroke="var(--color-danger)" stroke-linecap="round" stroke-linejoin="round"' })}
        </div>
        <h2>${title}</h2>
        <p class="confirm-message">${message}</p>
        <div class="modal-actions">
          <button type="button" class="btn btn-outline" data-action="cancel">${cancelLabel}</button>
          <button type="button" class="${confirmClassName}" data-action="confirm">${confirmLabel}</button>
        </div>
      </div>
    `;

    const close = (result: boolean) => {
      overlay.remove();
      resolve(result);
    };

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close(false);
    });
    overlay.querySelector('[data-action="cancel"]')!.addEventListener('click', () => close(false));
    overlay.querySelector('[data-action="confirm"]')!.addEventListener('click', () => close(true));

    document.addEventListener('keydown', function handler(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        document.removeEventListener('keydown', handler);
        close(false);
      }
    });

    document.body.appendChild(overlay);
    (overlay.querySelector('[data-action="cancel"]') as HTMLElement)?.focus();
  });
}
